export class PointHelper {
    static distance(a, b) {
        let x = a.x - b.x;
        let y = a.y - b.y;
        return Math.sqrt(x * x + y * y);
    }
    static distanceSquared(a, b) {
        let x = a.x - b.x;
        let y = a.y - b.y;
        return x * x + y * y;
    }
}
//# sourceMappingURL=PointHelper.js.map